import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { ROUTE_PATHS } from "../../../utilities/constants"

// "Compare groups" became "Compare departments" (2026-10-28): saved links keep their query string and hash.
const LegacyCompareGroupsRedirect = () => {
  const { search, hash } = useLocation()
  return <Navigate to={{ pathname: ROUTE_PATHS.COMPARE_DEPARTMENTS, search, hash }} replace />
}

export default LegacyCompareGroupsRedirect
